import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SavedBy } from "@/admin/Recorded";
import { AdminTitle, Btn, Pill } from "@/admin/AdminLayout";

const API_ROOT = process.env.REACT_APP_BACKEND_URL;
const TONE: Record<string, string> = { approved: "green", pending: "amber", rejected: "red" };

function Photo({ mid }: { mid: string }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url = "";
    api.get(`/admin-x/stories/media/${mid}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [mid]);
  return src ? <a href={src} target="_blank" rel="noreferrer"><img src={src} alt="" className="w-24 h-28 object-cover border" /></a> : <div className="w-24 h-28 bg-neutral-100" />;
}

export default function StoriesAdmin() {
  const [rows, setRows] = useState<any[]>([]);
  const load = () => api.get("/admin-x/stories").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const act = async (s: any, upd: any) => { try { await api.put(`/admin-x/stories/${s.id}`, { status: s.status, ...upd }); toast("Updated"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (s: any) => { if (window.confirm("Delete this story and its photos?")) { await api.delete(`/admin-x/stories/${s.id}`); load(); } };
  return (
    <div data-testid="admin-stories">
      <AdminTitle title="Said Yes Stories" sub="Proposal stories shared by couples. Approved stories appear in the Said Yes gallery on the Surprise Proposals page; featured ones show first." />
      <div className="space-y-4">
        {rows.map((s) => (
          <div key={s.id} className="bg-white border border-neutral-200 p-5 flex flex-col md:flex-row gap-5" data-testid={`story-row-${s.id}`}>
            <div className="flex gap-2 shrink-0">{(s.photos || []).map((p: any) => <Photo key={p.id} mid={p.id} />)}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 flex-wrap"><p className="font-display text-xl">{s.names}</p><Pill tone={TONE[s.status]}>{s.status}</Pill>{s.featured && <Pill tone="green">featured</Pill>}</div>
              <p className="text-xs text-neutral-500 mt-1">{s.place} · {s.email} · {new Date(s.created_at).toLocaleDateString("en-AU")}</p><SavedBy d={s} testId={`story-saved-${s.id}`} />
              <p className="text-sm mt-3 whitespace-pre-line">{s.story}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {s.status !== "approved" && <Btn onClick={() => act(s, { status: "approved" })} data-testid={`story-approve-${s.id}`}>Approve</Btn>}
                {s.status !== "rejected" && <Btn ghost onClick={() => act(s, { status: "rejected" })} data-testid={`story-reject-${s.id}`}>{s.status === "approved" ? "Hide" : "Reject"}</Btn>}
                <Btn ghost onClick={() => act(s, { featured: !s.featured })} data-testid={`story-feature-${s.id}`}>{s.featured ? "Unfeature" : "Feature"}</Btn>
                <Btn ghost onClick={() => del(s)} data-testid={`story-delete-${s.id}`}>Delete</Btn>
              </div>
            </div>
          </div>))}
        {!rows.length && <p className="text-sm text-neutral-500" data-testid="stories-empty">No stories yet. Couples can share theirs on the Surprise Proposals page.</p>}
      </div>
    </div>
  );
}
